export function getProfileImage(username) {
    let pfpNum = 0;
    for(let i = 0; i < username.length; i++) {
        pfpNum += username.charCodeAt(i);
    }
    pfpNum = (pfpNum % 20) + 1
    return 'https://basketball-mappings.s3.us-west-2.amazonaws.com/pfp' + pfpNum + '.png';
}